import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../home/components/Footer';

interface PortfolioItem {
  id: number;
  title: string;
  category: string;
  image: string;
  description: string;
  client: string;
  date: string;
}

export default function Portfolio() {
  const [selectedCategory, setSelectedCategory] = useState('Semua');
  const [selectedItem, setSelectedItem] = useState<PortfolioItem | null>(null);

  const categories = ['Semua', 'Desain', 'Foto', 'CCTV', 'Website', 'LED', 'Servis'];

  const portfolioItems: PortfolioItem[] = [
    {
      id: 1,
      title: 'Logo & Branding Warung Makan',
      category: 'Desain',
      image: 'https://public.readdy.ai/ai/img_res/422c276acf824062d2be30af3cff79d3.jpg',
      description: 'Desain logo dan identitas visual lengkap untuk warung makan lokal',
      client: 'Warung Bu Siti',
      date: 'Januari 2024'
    },
    {
      id: 2,
      title: 'Foto Produk UMKM',
      category: 'Foto',
      image: 'https://readdy.ai/api/search-image?query=professional%20product%20photography%20of%20traditional%20indonesian%20snacks%20and%20food%20items%20on%20clean%20white%20background%2C%20studio%20lighting%20setup%2C%20commercial%20food%20photography%2C%20simple%20minimalist%20background%20showcasing%20the%20products&width=600&height=400&seq=port2&orientation=landscape',
      description: 'Sesi foto produk untuk katalog online UMKM makanan ringan',
      client: 'Snack Nusantara',
      date: 'Februari 2024'
    },
    {
      id: 3,
      title: 'Instalasi CCTV Toko',
      category: 'CCTV',
      image: 'https://readdy.ai/api/search-image?query=modern%20security%20camera%20cctv%20installation%20in%20retail%20store%20interior%2C%20professional%20surveillance%20system%20setup%20with%20multiple%20cameras%2C%20clean%20organized%20installation%2C%20simple%20store%20background%20highlighting%20the%20security%20equipment&width=600&height=400&seq=port3&orientation=landscape',
      description: 'Pemasangan 8 unit CCTV dengan sistem remote monitoring',
      client: 'Toko Elektronik Jaya',
      date: 'Maret 2024'
    },
    {
      id: 4,
      title: 'Website Undangan Pernikahan',
      category: 'Website',
      image: 'https://readdy.ai/api/search-image?query=elegant%20wedding%20invitation%20website%20design%20displayed%20on%20laptop%20and%20mobile%20phone%20screens%2C%20romantic%20floral%20theme%20with%20soft%20pastel%20colors%2C%20modern%20digital%20invitation%20interface%2C%20clean%20simple%20background%20highlighting%20the%20website%20design&width=600&height=400&seq=port4&orientation=landscape',
      description: 'Undangan digital interaktif dengan fitur RSVP dan galeri foto',
      client: 'Rina & Budi',
      date: 'Februari 2024'
    },
    {
      id: 5,
      title: 'Running Text LED Masjid',
      category: 'LED',
      image: 'https://readdy.ai/api/search-image?query=modern%20led%20running%20text%20display%20board%20installed%20at%20mosque%20showing%20prayer%20times%20and%20islamic%20messages%2C%20digital%20signage%20with%20green%20and%20white%20colors%2C%20professional%20installation%2C%20simple%20mosque%20interior%20background%20highlighting%20the%20led%20display&width=600&height=400&seq=port5&orientation=landscape',
      description: 'Instalasi running text LED untuk jadwal sholat dan pengumuman',
      client: 'Masjid Al-Ikhlas',
      date: 'Januari 2024'
    },
    {
      id: 6,
      title: 'Banner Promosi Grand Opening',
      category: 'Desain',
      image: 'https://readdy.ai/api/search-image?query=vibrant%20grand%20opening%20promotional%20banner%20design%20with%20bold%20orange%20and%20navy%20blue%20colors%2C%20modern%20retail%20store%20opening%20advertisement%2C%20eye-catching%20marketing%20banner%2C%20clean%20simple%20background%20highlighting%20the%20banner%20design&width=600&height=400&seq=port6&orientation=landscape',
      description: 'Desain dan cetak banner ukuran 3x2 meter untuk grand opening',
      client: 'Cafe Kopi Kenangan',
      date: 'Maret 2024'
    },
    {
      id: 7,
      title: 'Servis Laptop Gaming',
      category: 'Servis',
      image: 'https://readdy.ai/api/search-image?query=professional%20laptop%20repair%20service%20workstation%20with%20gaming%20laptop%20being%20serviced%2C%20clean%20organized%20technician%20workspace%20with%20tools%20and%20equipment%2C%20computer%20hardware%20maintenance%2C%20simple%20workshop%20background%20highlighting%20the%20repair%20process&width=600&height=400&seq=port7&orientation=landscape',
      description: 'Upgrade RAM, SSD, dan pembersihan menyeluruh laptop gaming',
      client: 'Pak Agus',
      date: 'Februari 2024'
    },
    {
      id: 8,
      title: 'Foto Prewedding',
      category: 'Foto',
      image: 'https://readdy.ai/api/search-image?query=romantic%20prewedding%20photoshoot%20of%20indonesian%20couple%20in%20traditional%20and%20modern%20outfits%2C%20professional%20wedding%20photography%20with%20natural%20outdoor%20setting%2C%20beautiful%20couple%20portrait%2C%20simple%20natural%20background%20highlighting%20the%20couple&width=600&height=400&seq=port8&orientation=landscape',
      description: 'Sesi foto prewedding outdoor dan indoor dengan 100+ foto',
      client: 'Dina & Eko',
      date: 'Januari 2024'
    },
    {
      id: 9,
      title: 'Jam Digital Masjid',
      category: 'LED',
      image: 'https://readdy.ai/api/search-image?query=modern%20digital%20clock%20display%20for%20mosque%20showing%20prayer%20times%20temperature%20and%20date%2C%20islamic%20digital%20signage%20with%20green%20led%20display%2C%20professional%20installation%2C%20simple%20mosque%20wall%20background%20highlighting%20the%20digital%20clock&width=600&height=400&seq=port9&orientation=landscape',
      description: 'Instalasi jam digital dengan jadwal sholat otomatis',
      client: 'Masjid Nurul Huda',
      date: 'Maret 2024'
    }
  ];

  const filteredItems = selectedCategory === 'Semua' 
    ? portfolioItems 
    : portfolioItems.filter(item => item.category === selectedCategory);

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-gray-50">
      <Header />
      
      <div className="pt-32 pb-20">
        <div className="container mx-auto px-4">
          {/* Header */}
          <div className="text-center mb-12">
            <div className="inline-block mb-4">
              <span className="text-[#FF8A00] font-semibold text-sm uppercase tracking-wider bg-orange-50 px-4 py-2 rounded-full">
                Portofolio Kami
              </span>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-[#0B1F3B] mb-4">
              Hasil Karya & Proyek Kami
            </h1>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Lihat berbagai proyek yang telah kami kerjakan dengan hasil memuaskan
            </p>
          </div>

          {/* Category Filter */}
          <div className="flex flex-wrap justify-center gap-3 mb-12">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setSelectedCategory(category)}
                className={`px-6 py-3 rounded-xl font-semibold transition-all whitespace-nowrap cursor-pointer ${
                  selectedCategory === category
                    ? 'bg-[#FF8A00] text-white shadow-lg'
                    : 'bg-white text-gray-700 hover:bg-orange-50 hover:text-[#FF8A00] border border-gray-200'
                }`}
              >
                {category}
              </button>
            ))}
          </div>

          {/* Portfolio Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
            {filteredItems.map((item) => (
              <div
                key={item.id}
                onClick={() => setSelectedItem(item)}
                className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer border border-gray-200"
              >
                <div className="relative overflow-hidden aspect-[3/2]">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute top-4 right-4">
                    <span className="bg-[#FF8A00] text-white px-3 py-1 rounded-full text-sm font-semibold">
                      {item.category}
                    </span>
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-[#0B1F3B] mb-2 group-hover:text-[#FF8A00] transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-gray-600 text-sm mb-4 line-clamp-2">
                    {item.description}
                  </p>
                  <div className="flex items-center justify-between text-sm text-gray-500">
                    <span className="flex items-center gap-2">
                      <i className="ri-user-line"></i>
                      {item.client}
                    </span>
                    <span className="flex items-center gap-2">
                      <i className="ri-calendar-line"></i>
                      {item.date}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* CTA Section */}
          <div className="mt-16 bg-gradient-to-r from-[#0B1F3B] to-[#0d2847] rounded-3xl p-8 md:p-12 text-white text-center">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">
              Siap Wujudkan Proyek Anda?
            </h2>
            <p className="text-lg text-gray-300 mb-8 max-w-2xl mx-auto">
              Konsultasikan kebutuhan Anda dengan kami dan dapatkan solusi terbaik
            </p>
            <a
              href="https://wa.me/6285868360910"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 bg-[#25D366] hover:bg-[#20bd5a] text-white px-8 py-4 rounded-xl font-semibold text-lg transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-fill text-2xl"></i>
              Konsultasi Gratis
              <i className="ri-arrow-right-line text-xl"></i>
            </a>
          </div>
        </div>
      </div>

      {/* Detail Modal */}
      {selectedItem && (
        <div
          className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedItem(null)}
        >
          <div
            className="bg-white rounded-3xl max-w-4xl w-full max-h-[90vh] overflow-y-auto shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="relative">
              <img
                src={selectedItem.image}
                alt={selectedItem.title}
                className="w-full h-96 object-cover object-top"
              />
              <button
                onClick={() => setSelectedItem(null)}
                className="absolute top-4 right-4 w-10 h-10 flex items-center justify-center bg-white/90 hover:bg-white rounded-full transition-all cursor-pointer"
              >
                <i className="ri-close-line text-2xl text-[#0B1F3B]"></i>
              </button>
              <div className="absolute bottom-4 left-4">
                <span className="bg-[#FF8A00] text-white px-4 py-2 rounded-full font-semibold">
                  {selectedItem.category}
                </span>
              </div>
            </div>

            <div className="p-8">
              <h2 className="text-3xl font-bold text-[#0B1F3B] mb-4">
                {selectedItem.title}
              </h2>
              <p className="text-gray-600 text-lg mb-6 leading-relaxed">
                {selectedItem.description}
              </p>

              <div className="grid grid-cols-2 gap-4 mb-6">
                <div className="bg-gray-50 rounded-xl p-4">
                  <div className="flex items-center gap-2 text-gray-500 mb-1">
                    <i className="ri-user-line"></i>
                    <span className="text-sm">Klien</span>
                  </div>
                  <p className="font-semibold text-[#0B1F3B]">{selectedItem.client}</p>
                </div>
                <div className="bg-gray-50 rounded-xl p-4">
                  <div className="flex items-center gap-2 text-gray-500 mb-1">
                    <i className="ri-calendar-line"></i>
                    <span className="text-sm">Tanggal</span>
                  </div>
                  <p className="font-semibold text-[#0B1F3B]">{selectedItem.date}</p>
                </div>
              </div>

              <a
                href="https://wa.me/6285868360910"
                target="_blank"
                rel="noopener noreferrer"
                className="w-full bg-[#25D366] hover:bg-[#20bd5a] text-white py-4 rounded-xl font-semibold text-lg transition-all flex items-center justify-center gap-3 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-fill text-2xl"></i>
                Pesan Layanan Serupa
                <i className="ri-arrow-right-line text-xl"></i>
              </a>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
}